<template>
    <div class="submit-box">
        <div class="submit-btn">
            <el-button
				@click="dialogFormVisible = true"
				type="primary"
				icon="el-icon-message"
				circle
			></el-button>
            <el-button
				@click="dialogFormVisible2 = true"
				type="danger"
				icon="el-icon-edit"
				circle
				style="margin: 10px 0 0;"
			></el-button>
        </div>
		<div class="submit-div">
			<!-- <el-popover
				trigger="hover"
				placement="left"
			>
				<div class="imgwh">
					<img src="http://imgs-b2b.toocle.com/Public/home/images/wx-public.jpg" alt="">
				</div >
				<el-button
					slot="reference"
					type="warning"
					icon="el-icon-orange"
					circle
				></el-button>	
			</el-popover> -->
			<!-- <el-popover
				trigger="hover"
				placement="left"
			>
				<div class="imgwh">
					<img src="http://imgs-b2b.toocle.com/Public/home/images/code/wjs_xcx.jpg" alt="">
				</div >
				<el-button
					slot="reference"
					type="success"
					icon="el-icon-full-screen"
					circle
					style="margin: 10px 0 0;"
				></el-button>	
			</el-popover> -->
		</div>
        <el-dialog title="企业库入驻申请" :visible.sync="dialogFormVisible">
            <el-form
            action="/Index/bigemail.html"
            method="post"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
            id="postForm"
            class="demo-ruleForm">
                <el-form-item
                label="领域"
                prop="field">
                    <el-select
                    @change="getField"
                    v-model="ruleForm.field"
                    placeholder="请选择所属领域"
                    name="领域"
                    style="width: 100%;">
                        <el-option
                        v-for="item in $store.state.nav"
                        :key="item.field"
                        :label="item.field"
                        :value="item.field">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                v-if="$store.state.nav2.length != 0"
                label="类目"
                prop="category">
                    <el-select
                    v-model="ruleForm.category"
                    placeholder="请选择所属类目"
                    name="类目"
                    style="width: 100%;">
                        <el-option
                        v-for="item in $store.state.nav2"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                label="平台名称"
                prop="platform">
                    <el-input name="平台名称" v-model="ruleForm.platform"></el-input>
                </el-form-item>

                <el-form-item
                label="企业名称"
                prop="enterprise">
                    <el-input name="企业名称" v-model="ruleForm.enterprise"></el-input>
                </el-form-item>

                <!-- <el-form-item
                label="成立时间">
                    <el-input name="成立时间" v-model="ruleForm.setup"></el-input>
                </el-form-item>

                <el-form-item
                label="简介">
                    <el-input name="简介" v-model="ruleForm.introduce"></el-input>
                </el-form-item>

                <el-form-item
                label="LOGO"
                prop="logo">
                    <el-input name="LOGO" v-model="ruleForm.logo"></el-input>
                </el-form-item>

                <el-form-item
                label="官网">
                    <el-input name="官网" v-model="ruleForm.website"></el-input>
                </el-form-item>

                <el-form-item
                label="法定代表人">
                    <el-input name="法定代表人" v-model="ruleForm.behalf"></el-input>
                </el-form-item>

                <el-form-item
                label="省/市/区县">
                    <el-cascader
                    v-model="ruleForm.region"
                    placeholder="例如搜索：北京"
                    :options="region"
                    clearable
                    filterable
                    style="width: 100%;">
                    </el-cascader>
                    <el-input name="省/市/区县" v-model="ruleForm.region" style="width: 0; height: 0; opacity: 0;"></el-input>
                </el-form-item> -->

                <el-form-item
                label="电话/手机">
                    <el-input name="电话/手机" v-model="ruleForm.phone"></el-input>
                </el-form-item>

                <el-form-item
                label="邮箱"
                prop="email">
                    <el-input name="email" v-model="ruleForm.email"></el-input>
                </el-form-item>

                <el-form-item
                label="地址">
                    <el-input name="地址" v-model="ruleForm.address"></el-input>
                </el-form-item>

                <!-- <el-form-item
                label="注册资本">
                    <el-input name="注册资本" v-model="ruleForm.capital"></el-input>
                </el-form-item>

                <el-form-item
                label="核准日期">
                    <el-input name="核准日期" v-model="ruleForm.approval"></el-input>
                </el-form-item>

                <el-form-item
                label="统一社会信用代码">
                    <el-input name="统一社会信用代码" v-model="ruleForm.credit"></el-input>
                </el-form-item>

                <el-form-item
                label="纳税人识别号">
                    <el-input name="纳税人识别号" v-model="ruleForm.identify"></el-input>
                </el-form-item>

                <el-form-item
                label="组织机构代码">
                    <el-input name="组织机构代码" v-model="ruleForm.institutions"></el-input>
                </el-form-item>

                <el-form-item
                label="企业类型">
                    <el-input name="企业类型" v-model="ruleForm.type"></el-input>
                </el-form-item>

                <el-form-item
                label="所属行业">
                    <el-input name="所属行业" v-model="ruleForm.industry"></el-input>
                </el-form-item>

                <el-form-item
                label="曾用名">
                    <el-input name="曾用名" v-model="ruleForm.former"></el-input>
                </el-form-item> -->

                <el-form-item
                class="vcode-box"
                label="验证码"
                prop="vcode">
                    <div style="display: flex;">
                        <el-input name="verify" v-model="ruleForm.vcode"></el-input>
                        <img style="cursor:pointer;height:40px;" alt="验证码" src="/Index/verify.html" title="点击刷新" name="code_img" id="code_img" onclick="this.src='/Index/verify.html?d='+Math.random()">
                    </div>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('ruleForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="错误信息或补充信息反馈表" :visible.sync="dialogFormVisible2">
            <el-form
            action="/Index/bigemail.html"
            method="post"
            :model="ruleForm2"
            :rules="rules2"
            ref="ruleForm2"
            label-width="80px"
            id="postForm2"
            class="demo-ruleForm2">
                <el-form-item
                label="简要描述"
                prop="desc">
                    <el-input
                    type="textarea"
                    name="错误描述"
                    v-model="ruleForm2.desc"
                    :autosize="{ minRows: 5, maxRows: 10}"></el-input>
                </el-form-item>

                <el-form-item
                class="vcode-box"
                label="验证码"
                prop="vcode2">
                    <div style="display: flex;">
                        <el-input name="verify" v-model="ruleForm2.vcode2"></el-input>
                        <img style="cursor:pointer;height:40px;" alt="验证码" src="/Index/verify.html" title="点击刷新" name="code_img" id="code_img" onclick="this.src='/Index/verify.html?d='+Math.random()">
                    </div>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm2('ruleForm2')">取 消</el-button>
                <el-button type="primary" @click="submitForm2('ruleForm2')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'Submit',
    data() {
        return {
            // 入驻表单
            dialogFormVisible: false,
            labelPosition: 'right',
            ruleForm: {
                field: '',
                category: '',
                platform: '',
                enterprise: '',
                // setup: '',
                // introduce: '',
                // logo: '',
                // website: '',
                // behalf: '',
                // region: '',
                phone: '',
                email: '',
                address: '',
                // capital: '',
                // approval: '',
                // credit: '',
                // identify: '',
                // institutions: '',
                // type: '',
                // industry: '',
                // former: '',
                vcode: ''
            },
            rules: {
                field: [
                    {
                        required: true,
                        message: '请选择领域',
                        trigger: 'blur'
                    },
                ],
                category: [
                    {
                        required: true,
                        message: '请选择类目',
                        trigger: 'blur'
                    },
                ],
                platform: [
                    {
                        required: true,
                        message: '请输入平台名',
                        trigger: 'blur'
                    }
                ],
                // enterprise: [
                //     {
                //         required: true,
                //         message: '请输入企业名',
                //         trigger: 'blur'
                //     }
                // ],
                // logo: [
                //     {
                //         required: true,
                //         message: '请提供LOGO地址',
                //         trigger: 'blur'
                //     }
                // ],
                phone: [
                    {
                        required: true,
                        message: '请输入电话号码',
                        trigger: 'blur'
                    },
                    {
                        min: 8,
                        max: 11,
                        message: '请输入正确电话号码',
                        trigger: ['blur', 'change']
                    }
                ],
                email: [
                    {
                        required: true,
                        message: '请输入邮箱地址',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: '请输入正确邮箱地址',
                        trigger: ['blur', 'change']
                    }
                ],
                vcode: [
                    {
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    },
                ]
            },
            region: [],

            // 纠错表单
            dialogFormVisible2: false,
            ruleForm2: {
                desc: '',
                vcode2: ''
            },
            rules2: {
                desc: [
                    {
                        required: true,
                        message: '请简要描述错误信息',
                        trigger: 'blur'
                    },
                    {
                        min: 10,
                        max: 300,
                        message: '请输入10——300个字符',
                        trigger: ['blur', 'change']
                    }
                ],
                vcode2: [
                    {
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    },
                ]
            }
        }
    },
    // mounted() {
    //     CityInfo.forEach(item => {
    //         item.value = item.label
    //         item.children.forEach(item2 => {
    //             item2.value = item2.label
    //             item2.children.forEach(item3 => {
    //                 item3.value = item3.label
    //             })
    //         })
    //     })
    //     this.region = CityInfo
    // },
    methods: {
        getField() {
            this.$store.commit('getField2', this.ruleForm.field)
        },
        getVcode() {
            if(this.ruleForm.mobile.length != 11) {
                message.error('请输入正确手机号码');
            }else {
                axios({
				    method: 'post',
				    url: '/Home/Index/send_phone_msg',
				    data:{
				    	mobile: this.ruleForm.mobile
				    },
			    }).then((res) => {
                    if(res.data.code == 1) {
                        var time = setInterval(() => {
	                        if(this.vcodeNum > 0) {
                                this.vcodeNum -= 1
                                this.vcodeBtn = this.vcodeNum
                            }else {
                                clearInterval(time)
                                this.vcodeNum = 60
                                this.vcodeBtn = '发送验证码'
                            }
                        }, 1000)
                    }else if(res.data.code == 2) {
                        message.error(res.data.msg)
                    }
                })
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    this.$refs.ruleForm.$el.submit()
                }else {
                    return false
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
            this.dialogFormVisible = false
        },
        submitForm2(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    this.$refs.ruleForm2.$el.submit()
                }else {
                    return false
                }
            })
        },
        resetForm2(formName) {
            this.$refs[formName].resetFields()
            this.dialogFormVisible2 = false
        }
    }
}
</script>

<style scoped>
.submit-btn {
    width: 40px;
    position: fixed;
    right: 20px;
    bottom: 40px;
}
.submit-div {
	width: 40px;
	position: fixed;
	right: 20px;
	bottom: 140px;
}
.imgwh img {
	width: 140px;
}
</style>